import { BizAppConfig } from 'config/application.manifest';
import { createTenantManagementRequest } from '@/services/request';
import type { AuthorizedResource } from '@/permissions/adapter';
import type { ApiRequestOptions } from './types/common';

const request = createTenantManagementRequest();

export async function getMyAuthorizedResources(
  appId: string = BizAppConfig.appSsoClientId || '',
  options?: ApiRequestOptions,
) {
  const { params, ...restOptions } = options || {};

  return request<AuthorizedResource[]>(
    '/bff/permission/me/authorized-resources',
    {
      method: 'GET',
      ...restOptions,
      params: {
        appId,
        ...(params || {}),
      },
    },
  );
}
